import { render, staticRenderFns } from "./ModalShowBillExtraWithoutContractComponent.vue?vue&type=template&id=1ffad896&scoped=true"
import script from "./ModalShowBillExtraWithoutContractComponent.vue?vue&type=script&lang=js"
export * from "./ModalShowBillExtraWithoutContractComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalShowBillExtraWithoutContractComponent.vue?vue&type=style&index=0&id=1ffad896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffad896",
  null
  
)

export default component.exports